import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-900 min-h-screen w-full" }
const _hoisted_2 = { class: "px-4 py-8 mx-auto container" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center items-center py-10"
}
const _hoisted_4 = {
  key: 1,
  class: "bg-red-900 text-white p-4 rounded-lg mb-6"
}
const _hoisted_5 = {
  key: 2,
  class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full max-w-6xl mx-auto"
}
const _hoisted_6 = {
  key: 3,
  class: "bg-gray-800 rounded-lg p-8 text-center text-gray-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductsSearch = _resolveComponent("ProductsSearch")!
  const _component_ActiveFilters = _resolveComponent("ActiveFilters")!
  const _component_ProductCard = _resolveComponent("ProductCard")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-3xl font-bold text-white mb-6" }, "Proizvodi", -1)),
      _createVNode(_component_ProductsSearch, {
        onFilterChange: _ctx.handleFilterChange,
        "initial-filters": _ctx.activeFilters,
        ref: "searchComponent"
      }, null, 8, ["onFilterChange", "initial-filters"]),
      _createVNode(_component_ActiveFilters, {
        filters: _ctx.activeFilters,
        "filter-labels": _ctx.filterLabels,
        categories: _ctx.categories,
        onRemoveFilter: _ctx.removeFilter,
        onResetFilters: _ctx.resetFilters
      }, null, 8, ["filters", "filter-labels", "categories", "onRemoveFilter", "onResetFilters"]),
      (_ctx.showLoader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500" }, null, -1)
          ])))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
          : (_ctx.products.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: `product-${_ctx.currentPage}-${product.id}`,
                    to: {
            name: 'product-detail',
            params: { id: product.slug || product.id },
          },
                    class: "block w-full transition-transform duration-200 hover:-translate-y-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ProductCard, { product: product }, null, 8, ["product"])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ]))
            : (_ctx.showNoProducts)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Nema dostupnih proizvoda. "))
              : _createCommentVNode("", true),
      _createVNode(_component_PaginationComponent, {
        meta: _ctx.meta,
        "current-page": _ctx.currentPage,
        "update-url": true,
        onPageChange: _ctx.changePage
      }, null, 8, ["meta", "current-page", "onPageChange"])
    ])
  ]))
}